import * as React from 'react';
import { useState } from 'react';

import { Button } from '@rmwc/button';
import '@rmwc/button/styles';

import { Dialog, DialogTitle, DialogContent, DialogActions, DialogButton } from '@rmwc/dialog';
import '@rmwc/dialog/styles';

import { FeatherIcon } from './feather_icon';

import { PhaseSelect } from './phase_select';
import { SiteOverviewData } from '../types';
import { useUpdateSite } from './backend';

export interface PhaseDialogProps {
  site: SiteOverviewData;
  done: () => void;
};

export const PhaseDialog: React.FC<PhaseDialogProps> = ({ site, done }) => {
  const [phase, setPhase] = useState(site.phase);
  const mutation = useUpdateSite();

  const accept = async () => {
    try {
      await mutation.mutateAsync({
        id: site.id,
        comment: `Setting phase to '${phase}'`,
        phase,
      });

      done();
    } catch {
      alert("Unable to update backend");
    }
  };

  const disabled = mutation.isLoading;

  return <Dialog open={true} onClose={done}>
    <DialogTitle>Change Project Phase</DialogTitle>
    <DialogContent>
      <PhaseSelect disabled={disabled} value={phase} update={setPhase} />
    </DialogContent>
    <DialogActions>
      <DialogButton disabled={disabled} action="cancel">Cancel</DialogButton>
      <DialogButton disabled={disabled} isDefaultAction onClick={accept}>Save</DialogButton>
    </DialogActions>
  </Dialog>;
};

export interface PhaseButtonProps {
  site: SiteOverviewData;
}

export const PhaseButton: React.FC<PhaseButtonProps> = ({ site }) => {
  const [visible, setVisible] = useState(false);

  const open = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setVisible(true);
  };

  const done = () => {
    setVisible(false);
  };

  const dialog = visible ?  <PhaseDialog site={site} done={done} /> : null;

  return <>
    {dialog}
    <Button className="edit_button" onClick={open}>
      <FeatherIcon icon="edit-2" />
    </Button>
  </>;
};
